import lozad from 'lozad';

const userAgents = [
	'Bing',
	'google',
	'Ahrefs',
	'HubSpot Crawler',
	'AdsBot',
	'PTST',
	'Page Speed',
	'HeadlessChrome',
	'GTmetrix',
	'PingdomPageSpeed',
	'Chrome-Lighthouse',
];

const run = () => {
	let isUser = true;
	if (navigator.userAgent === 'isEapTest') {
		return true;
	}
	if (navigator.webdriver) {
		return false;
	}
	userAgents.forEach(user => {
		if (navigator.userAgent.toUpperCase().indexOf(user.toUpperCase()) !== -1) {
			isUser = false;
		}
	});
	return isUser;
};
export const isUser = run();
//  class="lozad" data-src="image.png"
// class="lozad" data-background-image="image.png">
// .lazyloaded_eap
// .eapLoader
const Loader = () => {
	document.addEventListener('DOMContentLoaded', () => {
		if (isUser) {
			const observer = lozad(); // lazy loads elements with default selector as '.lozad'
			observer.observe();

			const lazyEAP = document.querySelectorAll('.lazyloaded_eap');
			for (let i = 0; i < lazyEAP.length; i += 1) {
				if (
					typeof EAP.convertRelToAbsUrl === 'function' &&
					lazyEAP[i].getAttribute('src') === 'https://files.easyagentpro.com/eapLoader.png'
				) {
					lazyEAP[i].setAttribute(
						'src',
						`https://images.easyagentpro.com/images?url=${EAP.convertRelToAbsUrl(lazyEAP[i].dataset.eapsrc)}`
					);
				}
			}
			const eapLoader = document.querySelectorAll('.eapLoader');
			for (let z = 0; z < eapLoader.length; z += 1) {
				if (typeof EAP.convertRelToAbsUrl === 'function') {
					const newbg = EAP.convertRelToAbsUrl(eapLoader[z].dataset.eapsrc.replace(/["']+/g, ''));
					const containerwidth = eapLoader[z].offsetWidth * 2;

					eapLoader[z].style.backgroundImage = `url(https://images.easyagentpro.com/images?url=${newbg}&w=${containerwidth})`;
				}
			}
		}
	});
};
export default Loader;
